import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/Ishan/subs.vtt';
import poster from '@/static/assets/reviews/Ishan/video.jpg';

export const Ishan: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Ishan',
  videoUrl: `${ASSETS_URL}/car/Ishan.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
